export const queryKeys = {
    getAgencies: "getAgencies",
    getAgency: "getAgency",
  };
  